import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Tabs, Tab } from "react-bootstrap";
import SearchableSelect from "../../Components/SearchableSelect";
import { Link } from "react-router-dom";
import DatePicker from "../../Components/DatePicker/DatePicker";
import moment from "moment/moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import SearchInput from "../../Components/SearchInput";
import SellerOrders from "../../Components/Orders/SellerOrders";
import SellerPayments from "../../Components/Orders/SellerPayments";
const OrdersSellerPayments = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(10);
  const [statusSearch, setStatusSearch] = useState({ value: null, label: "All Payments" });
  const [fromDate, setFromDate] = useState(moment().subtract(100, "years")._d);
  const [toDate, setToDate] = useState(moment().add(100, "years")._d);
  const [search, setSearch] = useState("");
  const [currentTab, setCurrentTab] = useState("Orders");

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const searchStatus = (e) => {
    if (e.value) {
      setStatusSearch({ value: e.value, label: e.label });
    } else {
      setStatusSearch({ value: null, label: "All Payments" });
    }
    setCurrentPage(1);
  };

  const resetFilterHandle = (e) => {
    setSearch("");
    setStatusSearch({ value: null, label: "All Payments" });
    setFromDate(moment().subtract(100, "years")._d);
    setToDate(moment().add(100, "years")._d);
    setSizeOfPages(10);
    setCurrentPage(1);
  };
  const handleTabs = (e) => {
    setCurrentTab(e);
    resetFilterHandle();
    setSearch("");
  };
  return (
    <>
      <Container fluid>
        <Row className="d-flex align-items-center">
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <SearchInput searchlogo handleChange={handleChange} value={search} />
          </Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3"></Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <DatePicker important={true} fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate} />
          </Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <SearchableSelect
              placeholder="Filter Status"
              searchable={false}
              value={statusSearch}
              options={[
                { value: null, label: "All Payments" },
                { value: "Pending", label: "Pending" },
                { value: "Settled", label: "Settled" },
                { value: "Declined", label: "Declined" },
              ]}
              handleChange={searchStatus}
            />
          </Col>
          <Col xs="6" lg="3" xl="2" sm="3" className="mb-3">
            <SearchableSelect
              selectClassName={"bg-white"}
              placeholder={`Showing ${sizeOfPages}`}
              defaultValue={`Showing ${sizeOfPages}`}
              value={`Showing ${sizeOfPages}`}
              searchable={false}
              options={[
                { value: "10", label: "10" },
                { value: "20", label: "20" },
                { value: "30", label: "30" },
              ]}
              handleChange={(e) => setSizeOfPages(e.value)}
            />
          </Col>
          {currentTab === "Orders" ? (
            <Col xs="2" lg="2">
              <Link to="/orders/seller-payments/process-payments">
                <Button className="h-100 w-100 mb-3" size="sm" type="submit">
                  <span className="d-none d-lg-inline">Process Payment(s)</span> <FontAwesomeIcon icon={faPlus} />
                </Button>
              </Link>
            </Col>
          ) : (
            <></>
          )}
        </Row>
        <div className="pt-2">
          <Button size="sm" type="submit" style={{ fontSize: "14px" }} onClick={resetFilterHandle}>
            <span className="d-lg-inline">Reset Filters</span>{" "}
          </Button>
        </div>
        <Row style={{ marginBottom: "-3rem" }} className="mt-3">
          <Col>
            <Tabs defaultActiveKey="Orders" onSelect={handleTabs}>
              <Tab eventKey="Orders" title="Orders" className="text-secondary mb-5">
                <SellerOrders search={search} fromDate={fromDate} toDate={toDate} statusSearch={statusSearch} sizeOfPages={sizeOfPages} />
              </Tab>

              <Tab eventKey="Payments" title={`Payments`} className="text-secondary mb-5">
                <SellerPayments search={search} fromDate={fromDate} toDate={toDate} statusSearch={statusSearch} sizeOfPages={sizeOfPages} />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default OrdersSellerPayments;
